import React from "react";
import { Button, Card, CardHeader, Table } from "@opendate-app/setlist";

import { useBroadcastShowContext } from "./BroadcastShowContainer";
import TemplateHTMLPreview from "../BeefreeTemplates/TemplateHTMLPreview";
import { formatCount } from "./Report/reportMath";

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
  },
  name: {
    color: "var(--sl-text-primary)",
    fontSize: 16,
    fontWeight: 600,
  },
  link: {
    display: "block",
    maxWidth: 480,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  muted: {
    fontSize: 13,
    color: "var(--sl-text-tertiary)",
  },
  preview: {
    height: "75vh",
    width: "100%",
    overflow: "scroll",
    padding: 16,
    border: "1px solid var(--sl-border-secondary)",
    borderRadius: 8,
  },
};

const htmlContentStyle = {
  border: "none",
  height: "100%",
  overflow: "scroll",
  width: "100%",
  background: "#fff",
};

const BroadcastShow = () => {
  const {
    team,
    venueOwnership,
    broadcast,
    linkClicks,
  } = useBroadcastShowContext();

  const emailHtml = broadcast.beefree_template.template_html;

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div style={styles.name}>
          Broadcasts / {venueOwnership.venueable.name} / {broadcast.name}
        </div>
        <Button as="a" size="sm" href={`/teams/${team.id}/broadcasts/${broadcast.id}/edit`}>
          Edit
        </Button>
      </div>
      <Card padding="none" header={<CardHeader title="Link clicks" />}>
        <Table
          stackBelow={560}
          columns={[
            { key: "url", header: "Link", primary: true, render: (link) => <span style={styles.link} title={link.url}>{link.url}</span> },
            { key: "clicks", header: "Clicks", align: "right", render: (link) => formatCount(link.clicks) },
            { key: "unique_clicks", header: "Unique", align: "right", render: (link) => formatCount(link.unique_clicks) },
          ]}
          data={linkClicks}
          getRowKey={(link) => link.url}
          empty={<div style={styles.muted}>No link clicks tracked yet</div>}
        />
      </Card>
      <div style={styles.preview}>
        <TemplateHTMLPreview
          htmlContent={emailHtml}
          style={htmlContentStyle}
          disableLinks
        />
      </div>
    </div>
  );
};

export default BroadcastShow;
